import React, {useEffect} from 'react'
import './App.css'
import WOW from 'wow.js'
import Main from './Layout/Main/Main'
import Service from './Layout/Service/Service'
import Blog from './Layout/Blog/Blog'
import Call from './Layout/Call/Call'
import Footer from './Layout/Footer/Footer'
import Menu from './Layout/Menu/Menu'

function App() {
  useEffect(() => {
    new WOW({ mobile: false }).init()
  })

  return (
    <div className='App'>
      <Menu/>
      <Main/>
      <Service/>
      <Blog/>
      <Call/>
      <Footer/>
    </div>
  );
}

export default App;
